import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';

const CitySelector = ({
  onChanged,
  isMulti,
  selectedId,
}) => {
  const { countriesList } = useSelector(state => state.countries);
  const citiesOptions = countriesList.map(country => ({
    label: country.name,
    options: country.city.map(city => ({
      label: `${city.name} [${city.code}]`,
      value: city.id,
      code: city.code,
      country_id: country.id,
    })),
  }));
  let selectedItem;
  if (selectedId) {
    const [country] = citiesOptions.filter(
      c => c.options.find((city) => {
        if (Array.isArray(selectedId)) {
          return Array.from(selectedId).includes(city.value);
        }
        return city.value === selectedId;
      }) !== undefined,
    );
    if (country) {
      if (Array.isArray(selectedId)) {
        selectedItem = country.options.filter(x => Array.from(selectedId).includes(x.value));
      } else {
        selectedItem = country.options.find(x => x.value === selectedId);
      }
    }
  }
  return (
    <Select
      options={citiesOptions}
      value={selectedItem}
      placeholder="Select City..."
      isMulti={isMulti}
      onChange={(item) => {
        if (onChanged) {
          onChanged(item);
        }
      }}
    />
  );
};

CitySelector.propTypes = {
  onChanged: PropTypes.func,
  isMulti: PropTypes.bool,
  selectedId: PropTypes.number,
};

CitySelector.defaultProps = {
  onChanged: undefined,
  isMulti: false,
  selectedId: undefined,
};

export default CitySelector;
